module.exports = __webpack_public_path__ + "img/xxky2.98d6bd65.png";